import http from '@/utils/http'
import { SearchArgument } from '@/models/sub-message'
import {FormArgument} from '@/models/customer-good'
import Qs from 'qs'
import convert from '@/utils/model-convert'
const _AUTHORIZATION_URL = '/rest/support/authorization'
const SSO_LOGIN_URL = '/rest/boss/system/authorization/{id}'
const ALLMSG = '/rest/tourist/push-message/notifications'
const NOTREADMSG = '/rest/tourist/push-message/not/notifications'
const UPDATEINFO = '/rest/customer/system/users/updateInfo'
const UPLOAD_URL = '/rest/support/editor/kind/files?dir=image'
const MEES_URL = '/rest/customer/feedback/customer-messa'
const PASSWORD_URL = '/rest/support/authorization/password'

export default {
  passwordFn (data) {
    return http({
      url: PASSWORD_URL,
      method: 'PUT',
      data
    })
  },
  getUserAllMsg ({message}, cb) {
    http.get(ALLMSG, {params: convert.toJson(message, SearchArgument)})
      .then(response => cb(response))
      .catch(trace => cb(trace.response))
  },
  getUserNotReadMsg ({message}, cb) {
    http.get(NOTREADMSG, {params: convert.toJson(message, SearchArgument)})
      .then(response => cb(response))
      .catch(trace => cb(trace.response))
  },
  getInfo (cb) {
    http.get(_AUTHORIZATION_URL)
      .then(response => cb(response))
      .catch(trace => cb(trace.response))
  },
  login ({loginAccount, password, type}, cb) {
    // http login
    let postData = Qs.stringify({
      loginAccount: loginAccount,
      password: password,
      type: type
    })

    http.post(_AUTHORIZATION_URL, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(response => cb(response))
      .catch(trace => cb(trace.response))
  },
  logout (cb) {
    http.delete(_AUTHORIZATION_URL)
      .then(response => cb(response))
      .catch(trace => cb(trace.response))
  },
  ssoLogin ({id}, cb) {
    http.get(SSO_LOGIN_URL.replace('{id}', id))
      .then(response => cb(response))
      .catch(trace => cb(trace.response))
  },
  updateInfo ({form}, cb) {
    http.put(UPDATEINFO, form).then(response => cb(response))
      .catch(trace => cb(trace.response))
  },
  create ({form}, cb) {
    let postData = convert.toStringify(form, FormArgument)
    http.post(MEES_URL, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  thumbnailUpload ({form}, cb) {
    let formData = new FormData()
    formData.append('uploadGenre', 'image')
    formData.append('category', 'editor')
    formData.append('imgFile', form.imgFile)
    http.post(UPLOAD_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/system/user.js